<template>
  <div class="input-code-active">
    <label class="secondary-color-txt font-size-16 font-sanpro-semibold"
      >Mã kích hoạt</label
    >
    <div class="input-code-active__detail display-flex-center">
      <div
        class="
          input-code-active__input
          display-flex-center
          color_bg_gray_light
          border-0 border-rd-20
          full-width
        "
      >
        <input
          type="text"
          v-model="code1"
          ref="input_1"
          class="form-h30 border-rd-20 text-center border-0 color_bg_gray_light"
          style="width: 100%"
          @input="checkCompleteInput($event)"
        />
      </div>
      <i
        class="icon-minus color-light border-rd-50 cursor-pointer"
        @click="resetBookCode"
        :class="{ disabled: !code1 }"
      />
    </div>
  </div>
</template>

<script>
// CreatedBy: anhdd (8/12/2022)
const MAX_LENGTH_INPUT = 19;
const MAX_LENGTH_INPUT0 = 13;
export default {
  name: "InputCodeActive",
  props: {
    bookCodeDefault: String,
  },
  data() {
    return {
      code1: "",
      maxLengthInput: MAX_LENGTH_INPUT,
    };
  },
  mounted() {
    this.initCode();
  },
  methods: {
    initCode() {
      if (!this.bookCodeDefault) {
        return;
      }
      const valueSplit = this.bookCodeDefault;
      if (valueSplit.length > 0) {
        this.code1 = valueSplit;
      }
    },

    checkCompleteInput(e) {
      const self = this;
      let value = e.target.value;
      if (value.includes("-")) {
        if (self.code1.length >= MAX_LENGTH_INPUT) {
          self.code1 = value.substr(0, MAX_LENGTH_INPUT);
          self.$emit("inputDone", `${self.code1}`);
        }
      } else if (value.length >= MAX_LENGTH_INPUT0) {
        self.code1 = value.substr(0, MAX_LENGTH_INPUT0);
        self.$emit("inputDone", `${self.code1}`);
      }
    },

    resetBookCode() {
      this.code1 = "";
      this.$refs.input_1.focus();
      this.$emit("resetCode");
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  width: 70px;
  padding: 0;

  &:focus,
  &:active,
  &:visited {
    outline: 0;
  }
}
.dash {
  &:not(.opacity-1) {
    opacity: 0;
  }
}
.icon-minus {
  background: $red;
  margin-left: 5px;
}
</style>
